import { Grid2, TextField, Button } from '@mui/material'
import { useFormik } from 'formik'
import React from 'react'

import { PickupAddressType } from './../../../types/sellerType';
import { useAppDispatch } from '../../../State/Store';
import { updateSellerAccount } from '../../../State/seller/sellerSlice';
import { AddressFormSchema } from '../../../customer/pages/Checkout/AddressForm';

interface PickupAddressProp{
  pickupAddress: PickupAddressType|undefined
}
export const PickupAddress = (data:PickupAddressProp) => {
        const dispatch = useAppDispatch()
        const formik = useFormik({
          enableReinitialize:true,
          initialValues:{
            city:data.pickupAddress?.city||"",
            country:data.pickupAddress?.country||"",
            mobile:data.pickupAddress?.mobile||"",
            postalCode:data.pickupAddress?.postalCode||"",
            region:data.pickupAddress?.region||"",
            streetName:data.pickupAddress?.streetName||""
          },
          validationSchema: AddressFormSchema,
          onSubmit:async(values)=>{
            //submit form
          
          await  dispatch(updateSellerAccount({pickupAddress:values})).unwrap()
          }
        })
  return (
   
   
    <form>
        <Grid2 container spacing={3}>
            <Grid2 size={{xs:12}}>
                <TextField
                fullWidth
                name="streetName"
                label="Street Name"
                value={formik.values.streetName}
                onChange={formik.handleChange}
                error={formik.touched.streetName&& Boolean(formik.errors.streetName)}
                helperText={formik.touched.streetName && formik.errors.streetName}
                />
            </Grid2>
            <Grid2 size={{xs:6}}>
                <TextField
                fullWidth
                name="mobile"
                label="Mobile"
                value={formik.values.mobile}
                onChange={formik.handleChange}
                error={formik.touched.mobile&& Boolean(formik.errors.mobile)}
                helperText={formik.touched.mobile && formik.errors.mobile}
                />
            </Grid2>
            <Grid2 size={{xs:6}}>
                <TextField
                fullWidth
                name="postalCode"
                label="Postal Code"
                value={formik.values.postalCode}
                onChange={formik.handleChange}
                error={formik.touched.postalCode&& Boolean(formik.errors.postalCode)}
                helperText={formik.touched.postalCode && formik.errors.postalCode}
                />
            </Grid2>
            <Grid2 size={{xs:6}}>
                <TextField
                fullWidth
                name="city"
                label="City"
                value={formik.values.city}
                onChange={formik.handleChange}
                error={formik.touched.city&& Boolean(formik.errors.city)}
                helperText={formik.touched.city && formik.errors.city}
                />
            </Grid2>
            <Grid2 size={{xs:6}}>
                <TextField
                fullWidth
                name="region"
                label="Region"
                value={formik.values.region}
                onChange={formik.handleChange}
                error={formik.touched.region&& Boolean(formik.errors.region)}
                helperText={formik.touched.region && formik.errors.region}
                />
            </Grid2>
            <Grid2 size={{xs:12}}>
                <TextField
                fullWidth
                name="country"
                label="Country"
                value={formik.values.country}
                onChange={formik.handleChange}
                error={formik.touched.country&& Boolean(formik.errors.country)}
                helperText={formik.touched.country && formik.errors.country}
                />
            </Grid2>
            <Grid2 size={{xs:12}}>
                <Button fullWidth variant='contained' type='submit' onClick={(e) => { e.preventDefault();formik.handleSubmit() }}>
                  Submit
                </Button>
            </Grid2>
        
        </Grid2>
    </form>

  )
}
